import React, { Component } from 'react';
import { Row, Col, Form, InputGroup, Label, Button } from "reactstrap";
import { inject, observer } from "mobx-react";
import FormInputSimples from '../../comum/components/FormInputSimples';
import SelectFiltro from "../../comum/components/SelectFiltro";
import { FecharFiltro, DocumentoCheck } from '../../comum/components/Icones';
import Card from '../../comum/components/Card';


import lscache from "lscache";
import FormDateTimePicker from '../../comum/components/FormDateTimePicker';
import FormDatePicker from '../../comum/components/FormDatePicker';
@inject("store")
@observer
export default class FiltroLogs extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    filtrar() {
        this.setState(state => ({ filtrado: true }));
        this.controller.carregarLista();
    }

    componentDidMount() {
        this.checarFiltro();
    }

    checarFiltro() {

        lscache.flushExpired();



    }

    filtros = () => {

        return this.filtrosBasicos();

    };

    // filtrosCompletos = () => {
    //     let xl=3;let lg=6; let md=4; let sm=6; let xs=12;
    //     return <React.Fragment>
    //             <Row className="align-items-end">
    //                 <SelectFiltro titulo="Tipo" xl={xl} lg={lg} md={md} sm={sm} xs={xs}
    //                                 itens={this.controller.tiposAgendamento}
    //                                 valor={this.controller.tiposPreenchido}
    //                                 itensValor="Id" itensLabel="DscTipo"
    //                                 onChange={this.controller.setTipo} />

    //                 <SelectFiltro titulo="Operação" xl={xl} lg={lg} md={md} sm={sm} xs={xs}
    //                                 bloqueado={!this.controller.tiposPreenchido}
    //                                 itens={this.controller.operacoes}
    //                                 valor={this.controller.operacoesPreenchido}
    //                                 itensValor="Viagem" itensLabel="IdViagemDtPrev"
    //                                 onChange={this.controller.setOperacao}/>

    //                 <SelectFiltro titulo="Status" xl={xl} lg={lg} md={md} sm={sm} xs={xs}
    //                                 itens={this.controller.status}
    //                                 valor={this.controller.statusPreenchido}
    //                                 itensValor="Codigo" itensLabel="Descricao"
    //                                 onChange={this.controller.setStatus}/>

    //                 <FormInputSimples titulo="CNTR" xl={xl} md={md} sm={sm} xs={xs} uppercase={true} onEnter={() => this.filtrar()}
    //                                   dado={this.controller.container}
    //                                   onChange={(event) => this.controller.setContainer(event.target.value)}
    //                                   onBlur={(event) => this.controller.setContainer(event.target.value)}

    //                 />

    //                 <SelectFiltro titulo="Tamanho Container" xl={xl} lg={lg} md={md} sm={sm} xs={xs}
    //                                 itens={this.controller.tamanhos}
    //                                 valor={this.controller.tamanhoContainer}
    //                                 itensValor="Codigo" itensLabel="Descr"
    //                                 onChange={this.controller.setTamanhoContainer}/>

    //                 {process.env.ssa && <SelectFiltro titulo="Transportadora" xl={xl} lg={lg} md={md} sm={sm} xs={xs}
    //                                 itens={this.controller.transportadoras}
    //                                 valor={this.controller.transportadora}
    //                                 itensValor="TranspId" itensLabel="ApelidoTransp"
    //                                 onChange={this.controller.setTransportadora}/>}

    //                 <Col xl={xl} md={md} sm={sm} xs={xs} className="mb-4">
    //                     <div className="w-100">
    //                         <InputGroup className={`${this.controller.seletorPeriodo ? 'ativo' : ''} form-input-margin-remover adjust-size-single-date-input`}>
    //                                 <FormDatePicker titulo="Data Início" xs={12} sm={12} md={12} lg={12} xl={12}
    //                                     date={this.controller.dataInicial} 
    //                                     onChange={(value)=>this.controller.onChangeDataInicio(value)}
    //                                     //alerta={}
    //                                 />
    //                         </InputGroup>
    //                     </div>
    //                 </Col>
    //                 <Col xl={xl} md={md} sm={sm} xs={xs} className="mb-4">
    //                     <div className="w-100">
    //                         <InputGroup className={`${this.controller.seletorPeriodo ? 'ativo' : ''} form-input-margin-remover adjust-size-single-date-input`}>
    //                                 <FormDatePicker titulo="Data Fim" xs={12} sm={12} md={12} lg={12} xl={12}
    //                                     date={this.controller.dataFinal} 
    //                                     onChange={(value)=>this.controller.onChangeDataFim(value)}
    //                                 />
    //                         </InputGroup>
    //                     </div>
    //                 </Col>


    //                <FormInputSimples titulo="Placa" xl={xl} md={md} sm={sm} xs={xs} uppercase={true}  onEnter={() => this.filtrar()}
    //                                   dado={this.controller.placa}
    //                                   onChange={(event) => this.controller.setPlaca(event.target.value)}
    //                                   onBlur={(event) => this.controller.setPlaca(event.target.value)}
    //                 />


    //                 <FormInputSimples titulo="CNH" xl={xl} md={md} sm={sm} xs={xs}  onEnter={() => this.filtrar()}
    //                                   dado={this.controller.cnh}
    //                                   onChange={(event) => this.controller.setCnh(event.target.value)}
    //                                   onBlur={(event) => this.controller.setCnh(event.target.value)}
    //                 />

    //                 <FormInputSimples titulo="Booking" xl={xl} md={md} sm={sm} xs={xs} uppercase={true}  onEnter={() => this.filtrar()}
    //                                   dado={this.controller.booking}
    //                                   onChange={(event) => this.controller.setBooking(event.target.value)}
    //                                   onBlur={(event) => this.controller.setBooking(event.target.value)}
    //                 />

    //                 <Col sm={sm} xs={xs} className="mb-4 align-bottom">
    //                     <Button className="btn-filtros ativo" onClick={ () => this.mudaFiltros() } outline>
    //                         <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15"/>
    //                         Menos filtros
    //                     </Button>
    //                     <Button className="ml-1 btn-filtros" onClick={ () => this.controller.limparFiltros() } outline>
    //                         Limpar filtros
    //                     </Button>
    //                     <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.filtrar()} >Filtrar</Button>

    //                 </Col>
    //             </Row>
    //         </React.Fragment>
    // };

    filtrosBasicos = () => {
        let camposXl = 3;
        return <React.Fragment>
            <Row className="align-items-end">

                <SelectFiltro titulo="Tipo" xl={camposXl} md={4} sm={6} xs={12}
                    itens={this.controller.tiposLog}
                    valor={this.controller.tipoPreenchido}
                    itensValor="Id" itensLabel="DscTipoLog"
                    onChange={this.controller.setTipo} />


                <Col xl={camposXl} md={4} sm={6} xs={12} className="mb-4">
                    <InputGroup className={`${this.controller.seletorPeriodo ? 'ativo' : ''} form-input-margin-remover adjust-size-single-date-input`}>
                        <FormDatePicker titulo="Data Início" xs={12} sm={12} md={12} lg={12} xl={12}
                            date={this.controller.dataInicial}
                            onChange={(value) => this.controller.onChangeDataInicio(value)}
                        />
                    </InputGroup>
                </Col>
                <Col xl={camposXl} md={4} sm={6} xs={12} className="mb-4">
                    <InputGroup className={`${this.controller.seletorPeriodo ? 'ativo' : ''} form-input-margin-remover adjust-size-single-date-input`}>
                        <FormDatePicker titulo="Data Fim" xs={12} sm={12} md={12} lg={12} xl={12}
                            date={this.controller.dataFinal}
                            onChange={(value) => this.controller.onChangeDataFim(value)}
                        />
                    </InputGroup>
                </Col>
                <Col xl={camposXl} md={4} sm={6} xs={12} className="mb-4 align-bottom">
                    {/* <Button className="ml-1 btn-filtros" onClick={() => {}} outline>
                        Limpar filtros
                    </Button> */}
                    <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.filtrar()} >Filtrar</Button>
                </Col>
            </Row>
        </React.Fragment>
    };

    renderDados = () => {
        return (
            <Card className="mb-0">
                <div className="filtros agendamento m-0 p-0">
                    {this.filtros()}
                </div>
            </Card>
        )
    }

    render() {
        return <React.Fragment>
            {this.renderDados()}
        </React.Fragment>
    }
}


// WEBPACK FOOTER //
// ./src/modules/atualizacaocadastral/components/FiltroLogs.js